module.exports = __webpack_public_path__ + "img/image1.db4f39c9.png";